import { bindable, customElement } from 'aurelia-framework';
import { convertDate } from '../../resources/helper-functions/convertdate';
import { format, isValid, parse } from '../../date-fns-local';

@customElement('ag-date-editor')
export class AgDateEditor {

  input: HTMLInputElement;
  value: string;

  @bindable
  params: { value: string | Date };

  attached() {
    this.input.focus();
  }

  bind() {
    // A cell can hold no date at all (e.g. a manually added empty voucher) - format() would throw.
    this.value = this.params.value ? format(this.params.value, 'dd.MM.yyyy') : '';
  }

  getValue() {
    if (!this.value) {
      return null;
    }
    const parsed = parse(this.value, 'dd.MM.yyyy', new Date());
    return isValid(parsed) ? format(parsed, 'yyyy-MM-dd') : null;
  }

  isPopup() {
    return false;
  }

  focusIn() {
    this.input.focus();
  }

  getGui() {
    return this.input;
  }
}
